import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LinksComponent from '@/components/LinksComponent.vue';
import MainView from '@/views/MainView.vue';

const appName = 'Asesorias de Rentas';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Principal',
    component: MainView,
    meta: {
      title: appName
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title as string) || appName;
  next()
})


export default router
